import typeToReducer from 'type-to-reducer';
import set from 'lodash/set';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  RESET_EXCHANGE_FORM,
  GET_EXCHANGE_BY_ID,
  MODIFY_EDITING_EXCHANGE,
} from 'exchange/constants';

export const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: {},
};

export const resetForm = (state) => ({ ...initialState });

export const getByIdPending = (state) => ({ ...state, isFetching: true });

export const getByIdRejected = (state) => ({ ...state, isFetching: false });

export const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.exchange },
});

export const modifyExchange = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    ...payload,
  },
});

const reducers = {
  [RESET_EXCHANGE_FORM]: resetForm,
  [GET_EXCHANGE_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [MODIFY_EDITING_EXCHANGE]: modifyExchange,
};

export default typeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/reducers/exchange_form_reducers.js